import { Clock } from 'lucide-react';

export function formatRelativeTime(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 2) return 'just now';
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  return `${Math.floor(hrs / 24)}d ago`;
}

interface LastSyncedProps {
  iso: string | null | undefined;
  label?: string;
  className?: string;
}

const BASE_CLASS = 'flex items-center gap-1 text-[11px] text-gray-400 dark:text-gray-500';

export function LastSynced({ iso, label = 'Synced', className }: LastSyncedProps) {
  if (!iso) return null;
  return (
    <div className={className ? `${BASE_CLASS} ${className}` : BASE_CLASS}>
      <Clock className="w-3 h-3" />
      <span>{label} {formatRelativeTime(iso)}</span>
    </div>
  );
}
